import styled from 'styled-components';

export const CommentsSectionInputElementWrapper = styled.div`
    .input-value-wrapper,
    .input-value,
    input {
        width: 100%;
    }
    label .input-value-wrapper .input-value {
        text-align: left;
        width: 100%;
        display: block;
    }

    label .input-value-wrapper .input-unit {
        width: 0;
    }

    textarea {
        border-radius: 3px;
        border: 1px solid ${props => props.theme.colors.border.input};
        padding: 0.25rem 0.5rem;
        background: #fff;
        outline: ${props => props.theme.colors.border.grey};

        &:hover {
            border-color: ${props => props.theme.colors.border.inputHover};
        }
    }
`;
